<template>
  <v-layout justify-center id="safariWarning">
    <v-flex xs12 sm8 md8>
      <v-card class="elevation-12">
        <v-container
          class="title font-weight-bold divider-shadow warning-card"
          :class="{ 'round-bottoms' : !showMore }"
          @click="showMore=!showMore"
        >
          <span> {{$t('safariWarning.warning')}} </span>
          <img
            class="drop-down"
            :class="{ 'rotated' : showMore }"
            src="@/assets/art/arrow_drop_down.svg"
          />
        </v-container>
        <v-container v-show="showMore">
          <div>{{$t('safariWarning.explanation')}}</div>
          &nbsp;
          <div> {{$t('safariWarning.alternativeSuggestion')}} </div>
          <ul>
            <li>{{$t('safariWarning.wifiOption')}}</li>
            <li>{{$t('safariWarning.browserOption')}}</li>
            <li>{{$t('safariWarning.updateOption')}}</li>
          </ul>
          &nbsp;
          <div> {{$t('safariWarning.updateSuggestion')}}</div>
          <ol>
            <li>
              {{$t('safariWarning.updateStep1')}}
              <span class="font-weight-bold">{{$t('safariWarning.settings')}}</span>
            </li>
            <li>
              {{$t('safariWarning.updateStep2')}}
              <span class="font-weight-bold">{{$t('safariWarning.general')}}</span>
            </li>
            <li>
              {{$t('safariWarning.updateStep3')}}
              <span class="font-weight-bold">{{$t('safariWarning.softwareUpdate')}}</span>
            </li>
            <li>{{$t('safariWarning.updateStep4')}}</li>
          </ol>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'SafariWarning',
  props: {
    autoCloseWarning: Boolean
  },
  data: () => ({
    showMore: true
  }),
  watch: {
    autoCloseWarning (newVal, oldVal) {
      if (!oldVal && newVal) {
        this.showMore = false
      }
    }
  }
}
</script>
<style scoped>
#safariWarning {
  margin-bottom: 12px;
}
.warning-card {
  background-color: #FFC220;
  position: relative;
}
.round-bottoms {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}
.drop-down {
  height: 50%;
  position: absolute;
  right: 2%;
  transition: all 0.5s;
}
.rotated {
  transform: rotate(180deg);
  transition: all 0.5s;
}
</style>
